import {Controller, useFormContext} from "react-hook-form";
import {Input, Space} from "antd";
import {FormField, FormFieldError} from "../../../../../../../design-system/form-field";
import {CreateKycBasicFormStepFormValues} from "../../schema-validation";

export function KycBusinessNameFormField() {
  const {control} = useFormContext<CreateKycBasicFormStepFormValues>();

  return (
    <FormField
      id="businessName"
      label="Business name (optional)"
      renderInput={(id) => (
        <Controller
          control={control}
          name="businessName"
          render={({field: {onChange, value, ref, onBlur}, fieldState: {error}}) => (
            <Space size={8} direction="vertical" style={{display: "flex"}}>
              <Space size={4} direction="vertical" style={{display: "flex"}}>
                <Input
                  id={id}
                  status={error?.message ? "error" : ""}
                  onChange={onChange}
                  onBlur={onBlur}
                  size="large"
                  value={value === null ? undefined : value}
                  placeholder="Enter the business name associated with your account"
                  ref={ref}
                />
              </Space>
              <FormFieldError errorMessage={error?.message} />
            </Space>
          )}
        />
      )}
    />
  );
}
